enum InternationalPaymentTransactionStatus {
  ACSC = 'ACSC',
  PDNG = 'PDNG',
  RJCT = 'RJCT',
  PATC = 'PATC',
  ACSP = 'ACSP',
}

export default InternationalPaymentTransactionStatus;
